var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 6H24V2.5h-2V6H10V2.5H8V6H2.5A1.502 1.502 0 001 7.5v21A1.502 1.502 0 002.5 30h27a1.501 1.501 0 001.5-1.5v-21A1.502 1.502 0 0029.5 6zM29 28H3V8h5v2.5h2V8h12v2.5h2V8h5v20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14h2v2H7v-2zM12.5 14h2v2h-2v-2zM17.5 14h2v2h-2v-2zM23 14h2v2h-2v-2zM7 18.5h2v2H7v-2zM12.5 18.5h2v2h-2v-2zM17.5 18.5h2v2h-2v-2zM23 18.5h2v2h-2v-2zM7 23h2v2H7v-2zM12.5 23h2v2h-2v-2zM17.5 23h2v2h-2v-2zM23 23h2v2h-2v-2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.879a1400.svg";
export { ForwardRef as ReactComponent };